import type { TaskBasic, TaskItem, TaskQueryParams } from '../types';

export const GetTaskListRep = Symbol.for('GetTaskListRep');

export interface GetTaskListRep {
    fetch(params: TaskQueryParams): Promise<TaskBasic>;
}

export const GetTaskStatusRep = Symbol.for('GetTaskStatusRep');

export interface GetTaskStatusRep {
    fetch(taskIds: string[]): Promise<Pick<TaskItem, 'id' | 'status'>[]>;
}
